import { useEffect, useRef, useState } from 'react';

/**
 * 用于检测文本元素是否溢出的Hook
 * @param deps 依赖数组，当这些依赖项变化时重新检测溢出状态
 * @returns 返回一个包含ref和溢出状态的对象
 */
export function useTextOverflow(deps: React.DependencyList = []) {
  const [isTextOverflow, setIsTextOverflow] = useState(false);
  const elementRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const checkTextOverflow = () => {
      if (elementRef.current) {
        const hasOverflow = elementRef.current.scrollWidth > elementRef.current.clientWidth;
        setIsTextOverflow(hasOverflow);
      }
    };

    checkTextOverflow();

    window.addEventListener('resize', checkTextOverflow);

    return () => {
      window.removeEventListener('resize', checkTextOverflow);
    };
  }, [elementRef, ...deps]);

  return {
    ref: elementRef,
    isTextOverflow,
  };
}
